import { FC, ReactNode } from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import styles from './Message.module.scss';

type MessageProps = {
  icon?: IconDefinition;
  title?: string;
  messageText: string;
  children?: ReactNode;
  type?: 'error' | 'success';
};

const Message: FC<MessageProps> = ({
  icon,
  title,
  messageText,
  children,
  type = 'success',
}) => {
  return (
    <div className={classNames(styles.message, styles[type])}>
      {icon && <FontAwesomeIcon icon={icon} className={styles.icon} />}
      <div>
        {title && <h5>{title}</h5>}
        <p>{messageText}</p>
        {children}
      </div>
    </div>
  );
};

export default Message;
